import * as Phaser from "phaser";
import { generateScenes } from "./scenes";
import { SceneSetters } from "../types";

const generateGameConfig = (setters: SceneSetters): Phaser.Types.Core.GameConfig => ({
  title: "Sample",
  type: Phaser.AUTO,

  parent: "game",
  backgroundColor: "#2b2b2b",
  width: 600,
  height: 400,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_HORIZONTALLY,
  },
  dom: { createContainer: true },
  scene: generateScenes(setters),
});

export const initializeGame = (setters: SceneSetters) => {
  const gameConfig = generateGameConfig(setters);
  return new Phaser.Game(gameConfig);
};
